// @flow
import StudentsSelector from './StudentsSelector';

export default StudentsSelector;
